import { render } from "./student-dashboard.vue?vue&type=template&id=a865d40c&scoped=true"
import script from "./student-dashboard.vue?vue&type=script&lang=js"
export * from "./student-dashboard.vue?vue&type=script&lang=js"

import "./student-dashboard.vue?vue&type=style&index=0&id=a865d40c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a865d40c"]])

export default __exports__